import * as CommentActions from './comment.actions';
import * as CommentApiActions from './comment-api.actions';

export { CommentActions, CommentApiActions };
